export var AvatarProfileVariantType;
(function (AvatarProfileVariantType) {
    AvatarProfileVariantType["EMPTY"] = "EMPTY";
    AvatarProfileVariantType["EMPTY_MAIN_SECTION"] = "EMPTY_MAIN_SECTION";
    //
    AvatarProfileVariantType["ICON"] = "ICON";
    AvatarProfileVariantType["ICON_SELECTOR"] = "ICON_SELECTOR";
    //
    AvatarProfileVariantType["IMAGE"] = "IMAGE";
    AvatarProfileVariantType["IMAGE_WITH_BADGE"] = "IMAGE_WITH_BADGE";
    //
    AvatarProfileVariantType["INITIALS"] = "INITIALS";
    AvatarProfileVariantType["INITIALS_SELECTOR"] = "INITIALS_SELECTOR";
    AvatarProfileVariantType["INITIALS_WITH_BADGE"] = "INITIAL_WITH_BADGE";
    AvatarProfileVariantType["INITIALS_WITH_LOGO"] = "INITIALS_WITH_LOGO";
})(AvatarProfileVariantType || (AvatarProfileVariantType = {}));
//# sourceMappingURL=avatarProfileVariantType.js.map